/*
* 首页所有数据走全文检索接口
* */
import axios from 'axios'
// import pyChar from 'js-pinyin'
import gql from '@/graphql/apollo.js'

const state = {
    searchHistory: [],
    appList: [],
    filterAppList: [],
    tagList: [],
    depList: [],
    recommendList: [],
    guideList: [],
    tokenList: [],
    searchParams: {
        tag: '',
        dep: ''
    }
}

const getters = {
    getSearchHistory: () => state.searchHistory,
    getAppList: () => state.appList,
    getFilterAppList: () => state.filterAppList,
    getTagList: () => state.tagList,
    getDepList: () => state.depList,
    getRecommendList: () => state.recommendList,
    getGuideList: () => state.guideList,
}

const actions = {
    async searchGuideList({commit, state, dispatch}, keyword) {
        // https://cloud.ketanyun.cn/taskcenter-v4
        await axios.post(`${window.commonApi.TASKCENTER_URL}/manage/searchGuide?keyword=${keyword}`).then(res => {
            if (res.data.t) {
                let data = res.data.t;
                if (data.guideList) state.guideList = data.guideList;
                if (data.tokenList) state.tokenList = data.tokenList;
                let midList = data.appList
                //  .map(item => {
                //     return {
                //         hit: {
                //             ...item.hit,
                //             shouzimu: pyChar.getFullChars(item.hit.name).toUpperCase().slice(0, 1)
                //         }
                //     }
                // });
                if (keyword == '') {
                    state.appList = midList;
                    commit('filterAppData', state.appList);
                } else {
                    state.searchHistory = midList;
                    commit('filterAppData', state.searchHistory);
                    commit('appsHighLight', state.searchHistory);
                    commit('guidesHighLight', state.guideList);
                }
                commit('handleOtherData');

            }
        }).catch(error => {
            console.log(error);
        });
    },
    guideSearch({state}, keyword) {
        if (keyword !== '') {
            console.log(state.guideList,keyword)
            state.filterAppList = state.guideList.filter(item => item.hit.title.indexOf(keyword) > -1);
        } else {
            state.filterAppList = state.guideList;
        }
    },

    getRecommends({dispatch}) {
        axios.post(`${location.origin}${window.commonApi.PATH}/manage/apps/recommended`).then(res => {
            let recommends = [], appIdArr = [];
            if (res.data && res.data.entities) {
                recommends = res.data.entities;
            }
            if (recommends && recommends.length > 0) {
                for (let i = 0; i < recommends.length; i++) {
                    appIdArr.push(recommends[i].id);
                }
                if (appIdArr.length > 0) {
                    dispatch('getGlById', {appIdArr, metas: recommends})
                }
            }
        }).catch(error => {
            console.log(error);
        });
    },

    getGlById({state, commit}, {appIdArr, metas}) {
        apolloProvider.clients.manage.query({
            client: 'manage',
            query: gql.guide,
            variables: {
                appId: appIdArr
            }
        }).then(res => {
            let edges = res.data.guide.edges, recommends = metas.sort((a, b) => b.recommend - a.recommend);
            for (let i = 0; i < recommends.length; i++) {
                recommends[i].edges = [];
                let isOk = false;
                for (let j = 0; j < edges.length; j++) {
                    let guideStepList = edges[j].node.guideStepList;
                    for (let k = 0; k < guideStepList.length; k++) {
                        let guideStepAppList = guideStepList[k].guideStepAppList;
                        for (let d = 0; d < guideStepAppList.length; d++) {
                            if (guideStepAppList[d].appCode == recommends[i].code) {
                                recommends[i].edges.push(edges[j].node);
                                isOk = true;
                                break;
                            }
                        }
                        if (isOk) {
                            break;
                        }
                    }
                }
            }
            for (let i = 0; i < Math.ceil(recommends.length / 3); i++) {
                state.recommendList.push(recommends.splice(0, 3));
            }
        }).catch(error => {
            console.log(error);
        })
    },

    handleUpdateQuery({commit, state}, {tag, dep}) {
        state.searchParams.tag = tag || state.searchParams.tag;
        state.searchParams.dep = dep || state.searchParams.dep;
        if (tag === 'all') {
            state.searchParams.tag = '';
        }
        if (dep === 'all') {
            state.searchParams.dep = '';
        }
        commit('filterAppData');
    }
}
const mutations = {
    handleOtherData(state) {
        if (state.searchParams.tag) state.searchParams.tag = '';
        if (state.searchParams.dep) state.searchParams.dep = '';
        let appList = state.appList, tags = [], deps = [];
        if (appList.length > 0) {
            tags = appList.map(item => item.hit.tags && item.hit.tags.split(",")[1]);
            deps = appList.map(item => item.hit.tags && item.hit.tags.split(",")[0]);
        }
        state.tagList = Array.from(new Set(tags)).filter(item => item !== undefined).sort();
        state.depList = Array.from(new Set(deps)).filter(item => item !== undefined).sort();
    },

    filterAppData(state, appList) {
        if (appList) state.appList = appList;
        let allApps = state.appList, filterApps = [];
        for (let key in allApps) {
            let oneAppList = allApps[key];
            let paramsFlag = [false, false];
            if (state.searchParams.tag && oneAppList.hit.tags && oneAppList.hit.tags.indexOf(state.searchParams.tag) == -1) {
                paramsFlag[0] = true;
            }
            if (state.searchParams.dep && oneAppList.hit.tags && oneAppList.hit.tags.indexOf(state.searchParams.dep) == -1) {
                paramsFlag[1] = true;
            }
            if (paramsFlag.indexOf(true) == -1) {
                filterApps.push(oneAppList);
            }
        }
        state.filterAppList = filterApps;
    },

    appsHighLight(state, apps) {
        for (let j = 0; j < apps.length; j++) {
            let item = apps[j].hit;
            item.highLightName = item.name;
            item.highLightTags = item.tags ? item.tags.split(",").map(sortTag => {
                if (parseInt(sortTag.split("-")[0]) >= 0) {
                    return sortTag.replace(sortTag.split("-")[0] + '-', '');
                } else {
                    return sortTag;
                }
            }).join(",") : '';
            item.highLightDescription = item.description;
            if (state.tokenList && state.tokenList.length) {
                for (let i = 0; i < state.tokenList.length; i++) {
                    if (item.name) item.highLightName = item.highLightName.replace(state.tokenList[i], "<span style='color:red;'>" + state.tokenList[i] + "</span>");
                    if (item.tags) item.highLightTags = item.highLightTags.replace(state.tokenList[i], "<span style='color:red;'>" + state.tokenList[i] + "</span>");
                    if (item.description) item.highLightDescription = item.highLightDescription.replace(state.tokenList[i], "<span style='color:red;'>" + state.tokenList[i] + "</span>");
                }
            }
        }
    },

    guidesHighLight(state, guides) {
        for (let j = 0; j < guides.length; j++) {
            guides[j].hit.highLightTitle = guides[j].hit.title;
            guides[j].hit.highLightContext = guides[j].hit.keyword;
            if (state.tokenList && state.tokenList.length) {
                for (let i = 0; i < state.tokenList.length; i++) {
                    let key = state.tokenList[i];
                    if (guides[j].hit.title) {
                        guides[j].hit.highLightTitle = guides[j].hit.highLightTitle.replace(key, "<span style='color:red;'>" + key + "</span>");
                    }
                    if (guides[j].hit.keyword) {
                        guides[j].hit.highLightContext = guides[j].hit.highLightContext.replace(key, "<span style='color:red;'>" + key + "</span>");
                    }
                }
            }
        }
        state.guideList = guides.sort((a, b) => {
            let start = 0, end = 0;
            if (a.hit.sort) start = a.hit.sort
            if (b.hit.sort) end = b.hit.sort;
            return parseInt(end) - parseInt(start);
        })
    }
}
export default {
    state,
    getters,
    actions,
    mutations,
    namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/modules/manage.js